import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from "@angular/core";
import { DateRange } from "@enums/DateRange.enum";
import { TimeFilterType } from "@reports/enums/TimeFilterType";
import { TranslationService } from "@services/translation.service";
import { IVButtonDropDownItem } from "../../_core/v-button/v-button.component";
import "./v-time-filters.component.scss";

interface IQuickDate {
    label: string;
    dateRange: DateRange;
    selected?: boolean;
}

interface ITimeRestrictionOption {
    label: string;
    id: number;
}

@Component({
    selector: "v-time-filters",
    template: require("./v-time-filters.component.html")
})
export class VTimeFiltersComponent implements OnInit {
    @Input() showRangeFilter = true;
    @Input() showDailyFilter = true;

    @Input() timeFilterStart: string;
    @Input() timeFilterEnd: string;
    @Input() timeFilterType: TimeFilterType;

    @Input() increments: number = 30;

    @Output() timeFilterStartChange = new EventEmitter<string>();
    @Output() timeFilterEndChange = new EventEmitter<string>();
    @Output() timeFilterTypeChange = new EventEmitter<TimeFilterType>();

    // --

    TimeFilterType = TimeFilterType;

    selectedTimeRestrictionOption: IVButtonDropDownItem<ITimeRestrictionOption>;
    timeRestrictionOptions: IVButtonDropDownItem<ITimeRestrictionOption>[] = [];

    protected defaultTimeFilterStart: string = "08:00";
    protected defaultTimeFilterEnd: string = "17:00";

    // ---

    get enabledTimeFilterStart(): string {
        return (!!this.timeFilterStart) ? this.timeFilterStart : this.defaultTimeFilterStart;
    }

    get enabledTimeFilterEnd(): string {
        return (!!this.timeFilterEnd) ? this.timeFilterEnd : this.defaultTimeFilterEnd;
    }

    get enableRangeFilter(): boolean {
        return this.timeFilterType === TimeFilterType.Range;
    }

    get enableDailyFilter(): boolean {
        return this.timeFilterType === TimeFilterType.Daily;
    }

    constructor(
        private readonly translationService: TranslationService
    ) { }

    ngOnInit(): void {
        this.timeRestrictionOptions.push({ label: this.translationService.t("TimeFilters.StartEndTimeLabel"), id: 1 });
        this.timeRestrictionOptions.push({ label: this.translationService.t("TimeFilters.TimeFilterLabel"), id: 2 });

        this.selectedTimeRestrictionOption = this.timeRestrictionOptions[0];
    }

    ngOnChanges(): void {
        if (this.enableDailyFilter) {
            this.timeFilterStartChange.emit(this.enabledTimeFilterStart);
            this.timeFilterEndChange.emit(this.enabledTimeFilterEnd);
        }
    }

    onTimeFilterStartChanged(value: string, updateModel: boolean): void {
        if (!updateModel) {
            return;
        }

        this.changeStartTimeFilter(value);
    }

    onTimeFilterEndChanged(value: string, updateModel: boolean): void {
        if (!updateModel) {
            return;
        }

        this.changeEndTimeFilter(value);
    }

    onEnabledTimeFilterChanged(enabled: boolean, type: TimeFilterType): void {
        this.onTimeFilterStartChanged((enabled) ? (this.timeFilterStart || this.defaultTimeFilterStart) : null, true);
        this.onTimeFilterEndChanged((enabled) ? (this.timeFilterEnd ||this.defaultTimeFilterEnd) : null, true);

        this.changeFilterType((enabled) ? type : TimeFilterType.None);
    }

    // ---

    private changeFilterType(newType: TimeFilterType): void {

        if (newType === this.timeFilterType) {
            return;
        }

        this.timeFilterType = newType;
        this.timeFilterTypeChange.emit(this.timeFilterType);
    }

    private changeStartTimeFilter(value: string): void {
        if (value === this.timeFilterStart) {
            return;
        }

        this.timeFilterStart = value;
        this.timeFilterStartChange.emit(value);
    }

    private changeEndTimeFilter(value: string): void {

        if (value === this.timeFilterEnd) {
            return;
        }

        this.timeFilterEnd = value;
        this.timeFilterEndChange.emit(value);
    }

}
